import { QualityTypeEnum } from "@gtpl/shared-models/common-models";

export class AssignLotMaterialReq{
    lotNumber : string;
    workOrderNumber : string;
    quantity : number;
    prodInvId : number;
    createdUser : string;
    plantId : number;
    variantId : number;
    quality : QualityTypeEnum;
    lotVariantId : number;
    lotVariant : string;
    lotQuality : QualityTypeEnum;
    date : any;
    year : number;

    constructor(lotNumber : string,workOrderNumber : string,quantity : number,prodInvId : number,createdUser : string,plantId : number,variantId : number,quality : QualityTypeEnum,lotVariantId : number,lotVariant : string,lotQuality : QualityTypeEnum,date:any,year : number)
    {
        this.lotNumber = lotNumber;
        this.workOrderNumber = workOrderNumber;
        this.quantity = quantity;
        this.prodInvId = prodInvId;
        this.createdUser = createdUser;
        this.plantId = plantId;
        this.variantId = variantId;
        this.quality = quality;
        this.lotVariantId = lotVariantId;
        this.lotVariant = lotVariant
        this.lotQuality = lotQuality 
        this.date = date
        this.year = year
    }
}